

























































































import { Component, Vue } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import { mapGetters } from 'vuex';
import MobileMenuButton from '@/components/Layout/MobileMenuButton.vue';
import IdentityData from '@/ts/IdentityData';
import BaseDropDown from '@/components/DropDowns/BaseDropDown.vue';
import AccountSwitcherDropDown from '@/components/DropDowns/AccountSwitcher/AccountSwitcherDropDown.vue';

@Component({
    components: {
        MobileMenuButton,
        AccountSwitcherDropDown,
        BaseDropDown,
    },
    ...mapGetters({
        allLanguages: 'Localization/getAllLanguages',
    }),
})
export default class MobileAside extends Vue {
    // TODO: by Albert. userHasAccessTo('finances-management') - this is correct check for finances management (replace all 'false' tabs to this)

    public showLanguageDropDown: boolean = false;

    constructor() {
        super();
    }

    get identities(): IdentityData[] {
        return this.$store.getters['Identities/getIdentities'];
    }

    get allLanguages() {
        return this.$store.getters['Localization/getAllLanguages'];
    }

    get getGlobalLocalizationKey() {
        return this.$store.getters['Localization/getLocalizationKey'];
    }

    get role() {
        return this.$store.getters['User/getUser']
            ? this.$store.getters['User/getUser'].getMainRole
            : '';
    }

    get unreadMessageCountString(): string {
        const messageCount = this.$store.getters['Messages/unreadMessageCount'];

        if (!messageCount || messageCount === 0) {
            return '';
        }

        return ' (' + messageCount + ')';
    }

    get user() {
        return this.$store.getters['User/getUser'];
    }

    get corporationLinksEnabled() {
        const currentCorporation = this.$store.getters['Corporations/getCurrentCorporation'];
        if (currentCorporation) {
            const customLinksenabled = currentCorporation.custom_links_enabled;
            const userCorporationLinks = this.$store.getters['CorporationLinks/getUserCorporationLinks'];
            if (customLinksenabled && userCorporationLinks) {
                return userCorporationLinks.length > 0;
            }
        }
        return false;
    }

    public uploadTranslations() {
        this.showLanguageDropDown = false;
        this.$store.dispatch(Actions.SEND_MISSING_TRANSLATIONS);
    }

    public changeLanguage(lang: string) {
        this.showLanguageDropDown = false;
        this.$store.dispatch(Actions.GLOBAL_CHANGE_LANGUAGE, { vue: this, lang });
        this.$store.commit(Mutations.SET_LOCALIZATION_KEY, lang);
        this.$store.commit(Mutations.UPDATE_SELECTED_LANGUAGE_CODE, lang);
    }

    public beforeCreate() {
        this.$store.dispatch(Actions.FETCH_ALL_LANGUAGES);
    }

    public beforeMount() {
        this.$store.dispatch(Actions.FETCH_USER_CORPORATION_LINKS);
    }

    public userHasAccessTo(feature: string) {
        if (this.$store.getters['User/getUser'] === null) {
            return false;
        }

        return this.$store.getters['User/getUser'].hasAccessTo(feature);
    }

    private hideShelfMenu() {
        this.$store.dispatch(Actions.HIDE_SHELF);
    }

    private mobileLogOut() {
        this.hideShelfMenu();
        this.$store.dispatch(Actions.LOG_OUT);
    }
}
